"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewModel = void 0;
const nps_1 = require("@/utils/questions/nps");
function ViewModel(props, element) {
    const { design, startColor, endColor, gradientTextColor, value } = props;
    element.classList.add("fc-nps-item");
    element.setAttribute("data-nps-design", design.toString());
    const gradient = (0, nps_1.NPSGradient)(startColor, endColor);
    const point = Math.round(value);
    element.style.setProperty("--nps-color", gradient[point]);
    element.style.setProperty("--nps-text-color", gradientTextColor);
    return {
        value,
    };
}
exports.ViewModel = ViewModel;
